<section class="row">
  <div class="col">
    <ngx-datatable
      class="data-table table-responsive task-list-table"
      [rows]="data?.content"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [limit]="10"
      [rowHeight]="40"
    >
      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template>
          {{ 'Name' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          <app-host-mode-label [siteMode]="row.defaultSiteMode" />
          {{ row.name }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template> {{ 'IpSite' | translate }}s </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.ip ?? '-' }} | {{ row.ipv6 ?? '-' }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template>
          {{ 'Organization' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.owner.name }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template>
          {{ 'Cache' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          @if (row.supportsCache) {
            <span class="icofont icofont-ui-check text-success"></span>
          } @else {
            <span class="icofont icofont-ui-close text-danger"></span>
          }
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template>CDN</ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row.cdnCname ?? '-' }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column>
        <ng-template ngx-datatable-header-template>
          {{ 'Managed' | translate }}
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
          @if (row.managed) {
            <span class="icofont icofont-ui-check text-success"></span>
          } @else {
            <span class="icofont icofont-ui-close text-danger"></span>
          }
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <app-table-pager [data]="data" [page]="page" (changePage)="changePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</section>
